import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles,} from '@webs/components-library/theming';

@customElement('webs-footer')
export class Footer extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-site-footer {
        background-color: var(--color-dark-grey);
        padding: 5.5rem 0 1.5rem 0;
      }

      .left-column {
        margin-bottom: 3rem;
      }
    `,
  ];

  @property({attribute: 'hide-menu', type: Boolean})
  hideMenu: boolean;

  protected render(): unknown {
    return html`
      <footer class="m-site-footer">
        <div class="container">
          <webs-grid-row class="first-row">
            <webs-grid-column sm="4" lg="3">
              <div class="left-column">
                <slot name="footer-logo"></slot>
                <slot name="footer-subscription"></slot>
              </div>
            </webs-grid-column>

            ${!this.hideMenu ? html`
              <webs-grid-column sm="8" md="7" md-offset="1" lg="6" lg-offset="3">
                <slot name="footer-menu"></slot>
              </webs-grid-column>
            ` : ''}
          </webs-grid-row>

          <slot name="subfooter"></slot>
        </div>
      </footer>
    `;
  }
}
